<!--
 * @Descripttion: 
 * @version: 图片上传组件
 * @Author: wlk
 * @Date: 2023-11-28 15:23:45
 * @LastEditors: wlk
 * @LastEditTime: 2024-07-05 16:04:23
-->
<template>
  <Upload
    name="file"
    listType="picture-card"
    className="avatar-uploader"
    :headers="state.upLoadHeaders"
    :showUploadList="false"
    :action="state.upLoadUrl"
    :data="{ fileLifeEnum: 'FOREVER', returnUrl: true }"
    :beforeUpload="beforeUpload"
    v-model:file-list="fileList"
    @change="handleChange"
    accept=".png,.jpg,.jpeg"
  >
    <img
      style="width: 100%; height: 100%"
      v-if="state.imageUrl || imageUrl"
      :src="state.imageUrl || imageUrl"
      alt="avatar"
    />
    <div v-else>
      <LoadingOutlined v-if="state.loading"></LoadingOutlined>
      <PlusOutlined v-else></PlusOutlined>
      <div class="ant-upload-text">{{ $lang('上传图片') }}</div>
    </div>
  </Upload>
</template>

<script lang="ts" setup>
  import { reactive, ref } from 'vue'
  import { Upload, message } from 'ant-design-vue'
  import { PlusOutlined, LoadingOutlined } from '@ant-design/icons-vue'
  import type { UploadProps } from 'ant-design-vue'
  import { isSuccess } from '@/utils/index'
  import { useAuthStore } from '@/store/auth'
  import { lang } from '@/utils/index'
  const authStore = useAuthStore()
  const { VITE_APP_UPLOAD_URL } = import.meta.env

  interface Props {
    imageUrl: string
    imageSize: number
  }
  const props = defineProps<Props>()
  interface StateIn {
    loading: boolean
    imageUrl: string
    upLoadHeaders: { [key: string]: any }
    upLoadUrl: string
  }
  const getBase64 = (img: Blob, callback: (base64Url: string) => void) => {
    const reader = new FileReader()
    reader.addEventListener('load', () => callback(reader.result as string), { passive: false })
    reader.readAsDataURL(img)
  }
  const state: StateIn = reactive({
    loading: false,
    imageUrl: '',
    upLoadHeaders: {
      Authtoken: authStore.token,
      sysCode: 'WEB'
    },
    upLoadUrl: VITE_APP_UPLOAD_URL
  })

  const beforeUpload: any = (file: Blob) => {
    return new Promise((resolve) => {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
      const imageSize = props.imageSize || 2
      const isLt2MB = (file.size / 1024) * imageSize < 1024
      if (!isJpgOrPng) {
        message.error(lang('只能上传JPG或PNG格式文件!'))
        return false
      } else if (!isLt2MB) {
        message.error(lang('图片大小必须小于2MB!'))
        return false
      } else {
        return resolve(true)
      }
    })
  }

  const fileList = ref<UploadProps['fileList']>([])
  const emit = defineEmits(['update:value'])

  const handleChange = (info: any) => {
    if (info.file.status === 'uploading') {
      state.loading = true
      return
    }
    if (info.file.status === 'done') {
      let response = info.file.response
      state.loading = false
      if (isSuccess(response)) {
        // props.imgUpLoaded(info.file.response.data)
        emit('update:value', info.file.response.data.url)

        getBase64(info.file.originFileObj, (imageUrl: string) => {
          state.imageUrl = imageUrl
        })
      } else {
        message.error(response.msg || lang('上传出错'))
      }
    } else {
      state.loading = false
      message.error(lang('上传出错'))
    }
  }
</script>
